import axios from 'axios';
import * as React from 'react';
import { useEffect, useState } from 'react';
import SearchForm from '../../../../new_design/common/search_widget/search_form/common';
import { FilterParamsContext } from './filter_params_context';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {FilterParamsContextState} props.filterParams
 * @return {React.JSX.Element}
 * @constructor
 */
export const FilterParamsProvider = ({ children, ...props }) => {
  const [filterParams, setFilterParams] = useState(props.filterParams);

  /**
   * @param {Array<number>} tagsIds
   * @param {string} filterParamsProperty
   */
  const loadAdditionalTags = (tagsIds, filterParamsProperty) => {
    if (!tagsIds.length) return;
    if (filterParams[filterParamsProperty] != null && !Array.isArray(filterParams[filterParamsProperty])) return;

    const existingTagsIds = new Set((filterParams[filterParamsProperty] ?? []).map((tag) => Number(tag.id)));
    const tagsToLoadIds = tagsIds.filter((tagId) => !existingTagsIds.has(Number(tagId)));
    if (!tagsToLoadIds.length) return;

    axios.get(`/camp_service_tags/for_filter?tags_ids=${tagsToLoadIds.join(',')}`).then((response) => {
      setFilterParams((prevState) => ({
        ...prevState,
        [filterParamsProperty]: [...(prevState[filterParamsProperty] ?? []), ...response.data],
      }));
    });
  };

  /**
   * Загрузить профили лечения, которые выбраны в виджете поиска, но отсутствует в фильтрах слева
   */
  const loadTreatmentProfileFromSearch = () => {
    if (filterParams?.project !== 'kurortix.ru') return;

    SearchForm.getSearchData()
      .then(async (searchData) => {
        if (!searchData.camp_treatment_profiles) return;

        if (!filterParams.camp_treatment_profiles) return;

        const selectedTreatmentProfiles = [];
        for (const tagFromSearchData of searchData.camp_treatment_profiles.split(',')) {
          if (!filterParams.camp_treatment_profiles.some((tag) => tag.id === tagFromSearchData)) {
            selectedTreatmentProfiles.push(tagFromSearchData.split('|')[0]);
          }
        }
        loadAdditionalTags(selectedTreatmentProfiles, 'camp_treatment_profiles');
      })
      .catch(console.error);
  };

  useEffect(() => {
    loadTreatmentProfileFromSearch();
  }, []);

  /** @type {FilterParamsContextType} */
  const filterParamsContextValue = {
    filterParams,
    loadAdditionalTags,
    loadTreatmentProfileFromSearch,
  };

  return <FilterParamsContext.Provider value={filterParamsContextValue}>{children}</FilterParamsContext.Provider>;
};
